// @generated by protoc-gen-es-ns v0.0.0 with parameter "target=ts"
// @generated from file web/public/alert.proto (package web.public, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message web.public.Alert
 */
export class Alert extends Message<Alert> {
  /**
   * @generated from field: web.public.Alert.Type type = 1;
   */
  type = Alert.Type.INFO;

  /**
   * @generated from field: string icon = 2;
   */
  icon = "";

  /**
   * @generated from field: string title = 3;
   */
  title = "";

  /**
   * @generated from field: string text_md = 4;
   */
  textMd = "";

  /**
   * @generated from field: web.public.Alert.Cta cta = 5;
   */
  cta?: Alert.Cta;

  constructor(data?: PartialMessage<Alert>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "web.public.Alert";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "type", kind: "enum", T: proto3.getEnumType(Alert.Type) },
    { no: 2, name: "icon", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "title", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "text_md", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "cta", kind: "message", T: Alert.Cta },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Alert {
    return new Alert().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Alert {
    return new Alert().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Alert {
    return new Alert().fromJsonString(jsonString, options);
  }

  static equals(a: Alert | PlainMessage<Alert> | undefined, b: Alert | PlainMessage<Alert> | undefined): boolean {
    return proto3.util.equals(Alert, a, b);
  }

  static _enums: {
    Type: typeof Alert.Type,
  };
}

export namespace Alert {
  /**
   * @generated from enum web.public.Alert.Type
   */
  export enum Type {
    /**
     * @generated from enum value: INFO = 0;
     */
    INFO = 0,

    /**
     * @generated from enum value: WARNING = 1;
     */
    WARNING = 1,

    /**
     * @generated from enum value: ERROR = 2;
     */
    ERROR = 2,
  }
  // Retrieve enum metadata with: proto3.getEnumType(Alert.Type)
  proto3.util.setEnumType(Alert.Type, "web.public.Alert.Type", [
    { no: 0, name: "INFO" },
    { no: 1, name: "WARNING" },
    { no: 2, name: "ERROR" },
  ]);
}

export namespace Alert {
  /**
   * @generated from message web.public.Alert.Cta
   */
  export class Cta extends Message<Alert.Cta> {
    /**
     * @generated from field: string text = 1;
     */
    text = "";

    /**
     * @generated from field: string url = 2;
     */
    url = "";

    constructor(data?: PartialMessage<Alert.Cta>) {
      super();
      proto3.util.initPartial(data, this);
    }

    static readonly runtime: typeof proto3 = proto3;
    static readonly typeName = "web.public.Alert.Cta";
    static readonly fields: FieldList = proto3.util.newFieldList(() => [
      { no: 1, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
      { no: 2, name: "url", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    ]);

    static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): Alert.Cta {
      return new Alert.Cta().fromBinary(bytes, options);
    }

    static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): Alert.Cta {
      return new Alert.Cta().fromJson(jsonValue, options);
    }

    static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): Alert.Cta {
      return new Alert.Cta().fromJsonString(jsonString, options);
    }

    static equals(a: Alert.Cta | PlainMessage<Alert.Cta> | undefined, b: Alert.Cta | PlainMessage<Alert.Cta> | undefined): boolean {
      return proto3.util.equals(Alert.Cta, a, b);
    }

    static _enums: {
    };
  }
}

